module.exports = __webpack_public_path__ + "static/media/yugo-pin-small.0d855662.svg";